module.exports = __webpack_public_path__ + "static/media/green-black-leaf.9f265291.jpg";